import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

/* Material-UI Components */
import Button from '@material-ui/core/Button';

/* BCA Components */
import EquityForm from './components/EquityForm';
import InsuranceForm from './components/InsuranceForm';
import CashForm from './components/CashForm';
import ImmobilienForm from './components/ImmobilienForm';
import ExternalForm from './components/ExternalForm';
import withNotification from '../NotificationProvider';
import BaseDialog from "../BaseDialog/BaseDialog";

/* BCA modules */
import useStyles from './styles';
import { ASSET_MODAL_TYPE } from './constants';
import {PortfolioManagerResource} from "../../utils/api";


export default connect()(withNotification(withRouter((props) => {
  const classes = useStyles();

  const {
    asset,
    assetType,
    customerId,
    onModalClose,
    onAssetEdit,
  } = props;

  const [formData, setFormData] = React.useState(null);
  const [formDataErrors, setFormDataErrors] = React.useState([]);

  React.useEffect(() => {
    document.body.style.overflowY = asset ? 'hidden' : 'auto';
  }, [asset]);

  const handleModalClose = () => {
    if (onModalClose) {
      onModalClose();
    } 
  };

  const handleEditAsset = () => {
    const url = `customer/${customerId}/other-assets/${asset.id}/?asset_type=${assetType}`;
    PortfolioManagerResource.at(url).patch(formData)
    .then(() => {
      setFormDataErrors([]);
      onAssetEdit(formData.name);
    })
    .catch(error => {
      setFormDataErrors(error && error.data || error || []);
    });
  };

  const renderContent = () => {
    switch (assetType) {
      case ASSET_MODAL_TYPE.EQUITY: {
        return <EquityForm handleFormChange={setFormData} errors={formDataErrors} asset={asset}/>
      }
      case ASSET_MODAL_TYPE.INSURANCE: {
        return <InsuranceForm handleFormChange={setFormData} errors={formDataErrors} asset={asset}/>
      }
      case ASSET_MODAL_TYPE.CASH: {
        return <CashForm handleFormChange={setFormData} errors={formDataErrors} asset={asset}/>
      }
      case ASSET_MODAL_TYPE.IMMOBILIEN: {
        return <ImmobilienForm  handleFormChange={setFormData} errors={formDataErrors} asset={asset}/>
      }
      case ASSET_MODAL_TYPE.EXTERNAL: {
        return <ExternalForm  handleFormChange={setFormData} errors={formDataErrors} asset={asset} customerId={customerId} />
      }
      default: {
        return null
      }
    }
  };

  return (
    <BaseDialog
      open={!!asset}
      title={'Bearbeiten'}
      handleClose={handleModalClose}
      maxWidth={'md'}
      classes={
        {
          root: classes.root,
          paper: classes.paper
        }
      }
      customClasses={{dialogTitle: classes.modalTitle, dialogActions: classes.modalAction}}
      actions={
        <div>
          <Button onClick={handleModalClose} color="primary" className={classes.discardButton}>
            Schließen
          </Button>
          <Button onClick={handleEditAsset} color="primary" variant="contained" className={classes.acceptButton}>
            Speichern
          </Button>
        </div>
      }
    >
      <>
        {asset && assetType && renderContent()}
      </>
    </BaseDialog>
  );
})));